import { render, staticRenderFns } from "./BasicInformationAdd.vue?vue&type=template&id=657cfa0b&"
import script from "./BasicInformationAdd.vue?vue&type=script&lang=js&"
export * from "./BasicInformationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports